import ChildView from '@/components/layout/ChildView';
import EmptyView from '@/components/layout/EmptyView';

const viewRoutes = [
    {
        path: '/',
        name: 'home',
        meta: {
            icon: 'icon-caidanicon-gongzuotai-hui',
            title: '工作台',
        },
        title: '工作台',
        componentPath: 'home',
        component: () => import(/* webpackChunkName: "home" */ '@/views/home'),
    },
    {
        path: '/waybill-manage',
        meta: {
            icon: 'icon-caidanicon-yundanguanli-hui',
            title: '运单管理',
        },
        title: '运单管理',
        component: ChildView,
        children: [
            {
                path: '/waybill-manage-order-list',
                meta: {
                    icon: 'md-albums',
                    title: '运输订单',
                },
                title: '运输订单',
                componentPath: 'waybill-manage/order/list',
                component: () =>
                    import(
                        /* webpackChunkName: "waybill-manage-order-list" */ '@/views/waybill-manage/order/list'
                    ),
            },
            {
                path: '/waybill-manage-order-edit',
                meta: {
                    icon: 'md-albums',
                    title: '运单详情',
                },
                title: '运单详情',
                componentPath: 'waybill-manage/order/edit',
                component: () =>
                    import(
                        /* webpackChunkName: "waybill-manage-order-edit" */ '@/views/waybill-manage/order/edit'
                    ),
            },
            {
                path: '/waybill-manage-dispatch-singel-list',
                meta: {
                    icon: 'md-albums',
                    title: '调度单',
                    keepAlive: false,
                },
                title: '调度单',
                componentPath: 'waybill-manage/dispatch-singel/list',
                component: () =>
                    import(
                        /* webpackChunkName: "waybill-manage-dispatch-singel-list" */ '@/views/waybill-manage/dispatch-singel/list'
                    ),
            },
            {
                path: '/waybill-manage-dispatch-singel-edit',
                meta: {
                    icon: 'md-albums',
                    title: '调度单详情',
                },
                title: '调度单详情',
                componentPath: 'waybill-manage/dispatch-singel/edit',
                component: () =>
                    import(
                        /* webpackChunkName: "waybill-manage-dispatch-singel-edit" */ '@/views/waybill-manage/dispatch-singel/edit'
                    ),
            },
            {
                path: '/order-manage-list',
                meta: {
                    icon: 'md-albums',
                    title: '订单管理',
                    keepAlive: false,
                },
                title: '订单管理',
                componentPath: 'order-manage-list',
                component: () =>
                    import('@/views/waybill-manage/order-manage/list'),
            },
            {
                path: '/order-manage-edit',
                meta: {
                    icon: 'md-albums',
                    title: 'ETC安装计划单管理/新增',
                },
                title: '',
                componentPath: 'order-manage-edit',
                component: () =>
                    import('@/views/waybill-manage/order-manage/edit'),
            },
            {
                path: '/order-manage-detail',
                meta: {
                    icon: 'md-albums',
                    title: 'ETC安装计划单管理/详情',
                },
                title: '',
                componentPath: 'order-manage-detail',
                component: () =>
                    import('@/views/waybill-manage/order-manage/detail'),
            },
        ],
    },
    {
        path: '/operation-manage',
        meta: {
            icon: 'icon-caidanicon-yunyingguanli-hui',
            title: '运营管理',
        },
        title: '运营管理',
        component: ChildView,
        children: [
            {
                path: '/operation-manage-carrier-list',
                meta: {
                    icon: 'md-albums',
                    title: '承运商管理',
                },
                title: '承运商管理',
                componentPath: 'operation-manage/carrier/list',
                component: () =>
                    import(
                        /* webpackChunkName: "operation-manage-carrier-list" */ '@/views/operation-manage/carrier/list'
                    ),
            },
            {
                path: '/operation-manage-carrier-edit',
                meta: {
                    icon: 'md-albums',
                    title: '承运商开户',
                },
                title: '承运商开户',
                componentPath: 'operation-manage/carrier/edit',
                component: () =>
                    import(
                        /* webpackChunkName: "operation-manage-carrier-edit" */ '@/views/operation-manage/carrier/edit'
                    ),
            },
            {
                path: '/operation-manage-driver-list',
                meta: {
                    icon: 'md-albums',
                    title: '司机管理',
                },
                title: '司机管理',
                componentPath: 'operation-manage/driver/list',
                component: () =>
                    import(
                        /* webpackChunkName: "operation-manage-driver-list" */ '@/views/operation-manage/driver/list'
                    ),
            },
            {
                path: '/operation-manage-driver-edit',
                meta: {
                    icon: 'md-albums',
                    title: '司机信息编辑',
                },
                title: '司机管理编辑',
                componentPath: 'operation-manage/driver/edit',
                component: () =>
                    import(
                        /* webpackChunkName: "operation-manage-driver-edit" */ '@/views/operation-manage/driver/edit'
                    ),
            },
            {
                path: '/operation-manage-car-model-list',
                meta: {
                    icon: 'md-albums',
                    title: '车型管理',
                },
                title: '车型管理',
                componentPath: 'operation-manage/car-model/list',
                component: () =>
                    import(
                        /* webpackChunkName: "operation-manage-car-model-list" */ '@/views/operation-manage/car-model/list'
                    ),
            },
            {
                path: '/operation-manage-car-model-edit',
                meta: {
                    icon: 'md-albums',
                    title: '车型编辑',
                },
                title: '车型编辑',
                componentPath: 'operation-manage/car-model/edit',
                component: () =>
                    import(
                        /* webpackChunkName: "operation-manage-car-model-edit" */ '@/views/operation-manage/car-model/edit'
                    ),
            },
            {
                path: '/operation-manage-handler-list',
                meta: {
                    icon: 'md-albums',
                    title: '经办人管理',
                },
                title: '经办人管理',
                componentPath: 'operation-manage/handler/list',
                component: () =>
                    import(
                        /* webpackChunkName: "operation-manage-handler-list" */ '@/views/operation-manage/handler/list'
                    ),
            },
            {
                path: '/operation-manage-handler-edit',
                meta: {
                    icon: 'md-albums',
                    title: '经办人编辑',
                },
                title: '经办人编辑',
                componentPath: 'operation-manage/handler/edit',
                component: () =>
                    import(
                        /* webpackChunkName: "operation-manage-handler-edit" */ '@/views/operation-manage/handler/edit'
                    ),
            },
        ],
    },
    {
        path: '/etc-equipment-manage',
        meta: {
            icon: 'icon-caidanicon-ETCshebei-hui',
            title: 'ETC设备管理',
        },
        title: 'ETC设备管理',
        component: ChildView,
        children: [
            {
                path: '/etc-equipment-manage-equipment-list',
                meta: {
                    icon: 'md-albums',
                    title: '设备管理',
                },
                title: '设备管理',
                componentPath: 'etc-equipment-manage/equipment/list',
                component: () =>
                    import(
                        /* webpackChunkName: "etc-equipment-manage-equipment-list" */ '@/views/etc-equipment-manage/equipment/list'
                    ),
            },
            {
                path: '/etc-equipment-manage-equipment-edit',
                meta: {
                    icon: 'md-albums',
                    title: '设备信息',
                },
                title: '设备信息',
                componentPath: 'etc-equipment-manage/equipment/edit',
                component: () =>
                    import(
                        /* webpackChunkName: "etc-equipment-manage-equipment-edit" */ '@/views/etc-equipment-manage/equipment/edit'
                    ),
            },
            {
                path: '/etc-equipment-manage-card-list',
                meta: {
                    icon: 'md-albums',
                    title: '设备信息',
                },
                title: '设备信息',
                componentPath: 'etc-equipment-manage/card/list',
                component: () =>
                    import(
                        /* webpackChunkName: "etc-equipment-manage-card-list" */ '@/views/etc-equipment-manage/card/list'
                    ),
            },
            {
                path: '/etc-equipment-manage-obu-list',
                meta: {
                    icon: 'md-albums',
                    title: 'OBU管理',
                },
                title: 'OBU管理',
                componentPath: 'etc-equipment-manage/obu/list',
                component: () =>
                    import(
                        /* webpackChunkName: "etc-equipment-manage-card-list" */ '@/views/etc-equipment-manage/obu/list'
                    ),
            },
            {
                path: '/etc-equipment-manage-init-contract',
                meta: {
                    icon: 'md-albums',
                    title: '设备出厂管理',
                },
                title: '设备出厂管理',
                componentPath: 'etc-equipment-manage/initContract/list',
                component: () =>
                    import(
                        /* webpackChunkName: "etc-equipment-manage-initContract-list" */ '@/views/etc-equipment-manage/initContract/list'
                    ),
            },
        ],
    },
    {
        path: '/finance-manage',
        meta: {
            icon: 'icon-caidanicon-caiwuguanli-hui',
            title: '财务管理',
        },
        title: '财务管理',
        component: ChildView,
        children: [
            {
                path: '/finance-manage-settlement-list',
                meta: {
                    icon: 'md-albums',
                    title: '结算管理',
                },
                title: '结算管理',
                componentPath: 'finance-manage/settlement/list',
                component: () =>
                    import(
                        /* webpackChunkName: "finance-manage-settlement-list" */ '@/views/finance-manage/settlement/list'
                    ),
            },
            {
                path: '/finance-manage-settlement-edit',
                meta: {
                    icon: 'md-albums',
                    title: '结算详情',
                },
                title: '结算详情',
                componentPath: 'finance-manage/settlement/edit',
                component: () =>
                    import(
                        /* webpackChunkName: "finance-manage-settlement-edit" */ '@/views/finance-manage/settlement/edit'
                    ),
            },
            {
                path: '/finance-manage-bill-list',
                meta: {
                    icon: 'md-albums',
                    title: '结算账单',
                },
                title: '结算账单',
                componentPath: 'finance-manage/bill/list',
                component: () =>
                    import(
                        /* webpackChunkName: "finance-manage-invoice-list" */ '@/views/finance-manage/bill/list'
                    ),
            },
            {
                path: '/finance-manage-invoice-list',
                meta: {
                    icon: 'md-albums',
                    title: '发票管理',
                },
                title: '发票管理',
                componentPath: 'finance-manage/invoice/list',
                component: () =>
                    import(
                        /* webpackChunkName: "finance-manage-invoice-list" */ '@/views/finance-manage/invoice/list'
                    ),
            },
            {
                path: '/finance-manage-invoice-edit',
                meta: {
                    icon: 'md-albums',
                    title: '发票详情',
                },
                title: '发票详情',
                componentPath: 'finance-manage/invoice/edit',
                component: () =>
                    import(
                        /* webpackChunkName: "finance-manage-invoice-edit" */ '@/views/finance-manage/invoice/edit'
                    ),
            },
            {
                path: '/finance-manage-invoice-detail',
                meta: {
                    icon: 'md-albums',
                    title: '发票明细管理',
                },
                title: '发票明细管理',
                componentPath: 'finance-manage/invoice-detail/list',
                component: () =>
                    import(
                         '@/views/finance-manage/invoice-detail/list'
                        ),
            },
            {
                path: '/settlement-detail',
                meta: {
                    icon: 'md-albums',
                    title: '应结明细',
                },
                name: 'settlementDetail',
                title: '应结明细',
                componentPath: '/settlement-detail',
                component: () =>
                    import('@/views/finance-manage/settlement-detail/list'),
            },
            {
                path: '/settlement-summary',
                meta: {
                    icon: 'md-albums',
                    title: '应结汇总',
                },
                title: '应结汇总',
                componentPath: '/settlement-summary',
                component: () =>
                    import('@/views/finance-manage/settlement-summary/list'),
            },
        ],
    },
    {
        path: '/setting',
        meta: {
            icon: 'icon-caidanicon-xitongshezhi-hui',
            title: '设置',
        },
        title: '设置',
        component: ChildView,
        children: [
            {
                path: '/setting-user-list',
                meta: {
                    title: '用户管理',
                    icon: 'md-albums',
                },
                title: '用户管理',
                componentPath: 'setting/user-list',
                component: () =>
                    import(
                        /* webpackChunkName: "setting-user-list" */ '@/views/setting/user-list'
                    ),
            },
            {
                path: '/setting-resource-manage',
                meta: {
                    title: '资源管理',
                    icon: 'md-albums',
                },
                title: '资源管理',
                componentPath: 'setting/roleresource-manage',
                component: () =>
                    import(
                        /* webpackChunkName: "setting-resource-manage" */ '@/views/setting/resource-manage'
                    ),
            },
            {
                path: '/setting-role-role-list',
                meta: {
                    title: '角色管理',
                    icon: 'md-albums',
                },
                title: '角色管理',
                componentPath: 'setting/role/role-list',
                component: () =>
                    import(
                        /* webpackChunkName: "setting-role-role-list" */ '@/views/setting/role/role-list'
                    ),
            },
            {
                path: '/setting-role-role-assign',
                meta: {
                    title: '角色权限',
                    icon: 'md-albums',
                },
                hide: true,
                title: '角色权限',
                componentPath: 'setting/role/role-assign',
                component: () =>
                    import(
                        /* webpackChunkName: "setting-role-role-assign" */ '@/views/setting/role/role-assign'
                    ),
            },
            {
                path: '/setting-sys',
                meta: {
                    title: '系统设置',
                    icon: 'md-albums',
                },
                title: '系统设置',
                component: ChildView,
                children: [
                    {
                        path: '/sys-dictManageList',
                        name: 'dictManageList',
                        componentPath: 'sys/dictManager/dictList',
                        component: () =>
                            import(
                                /* webpackChunkName: "sys-dictManager-dictList" */ '@/views/sys/dictManager/dictList'
                            ),
                        meta: {
                            title: '数据字典',
                            icon: 'md-albums',
                        },
                        title: '数据字典',
                    },
                    {
                        path: '/setting-configure-list',
                        meta: {
                            title: '配置项管理',
                            icon: 'md-albums',
                        },
                        title: '配置项管理',
                        componentPath: 'setting/configure/configure-list',
                        component: () =>
                            import(
                                /* webpackChunkName: "setting-configure-configure-list" */ '@/views/setting/configure-list'
                            ),
                    },
                ],
            },
            {
                path: '/setting-login-log-list',
                meta: {
                    title: '登录日志',
                    icon: 'md-albums',
                },
                title: '登录日志',
                componentPath: 'setting/login-log/list',
                component: () =>
                    import(
                        /* webpackChunkName: "setting-login-log-list" */ '@/views/setting/login-log/list'
                    ),
            },
            {
                path: '/setting-operate-log-list',
                meta: {
                    title: '操作日志',
                    icon: 'md-albums',
                },
                title: '操作日志',
                componentPath: 'setting/operate-log/list',
                component: () =>
                    import(
                        /* webpackChunkName: "setting-operate-log-list" */ '@/views/setting/operate-log/list'
                    ),
            },
        ],
    },
];
export default [
    ...viewRoutes,
    /*    {
        path: '/git-version-info',
        name: 'git-version-info',
        meta: {
            title: 'git版本信息',
        },
        hide: true,
        component: () =>
            import(
                /!* webpackChunkName: "git-version-info" *!/ '@/views/version'
            ),
    },*/
    {
        path: '/login',
        name: 'login',
        meta: {
            title: '登录',
        },
        hide: true,
        component: () =>
            import(/* webpackChunkName: "login" */ '@/views/login/login'),
    },
    {
        path: '/notFound',
        name: 'error',
        meta: {
            title: '404',
        },
        hide: true,
        component: () =>
            import(/* webpackChunkName: "notFound" */ '@/views/notFound'),
    },
    {
        path: '/notAuth',
        name: 'notAuth',
        meta: {
            title: '暂无权限',
        },
        hide: true,
        component: EmptyView,
    },
];
